import { type ReactNode, useId, useLayoutEffect, useRef } from 'react';

export function ArenaChoice({
  open,
  title,
  onClose,
  children,
  presentation = 'standard',
}: {
  readonly open: boolean;
  readonly title: string;
  readonly onClose: () => void;
  readonly children: ReactNode;
  readonly presentation?: 'standard' | 'result' | 'page';
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useLayoutEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);
  return (
    <dialog
      ref={ref}
      className={`arena-choice arena-choice--${presentation}`}
      aria-labelledby={presentation !== 'result' ? titleId : undefined}
      aria-label={presentation === 'result' ? title : undefined}
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
    >
      {presentation !== 'result' && (
        <header>
          {presentation === 'page' && (
            <button type="button" className="arena-back" onClick={onClose}>
              ‹ Назад
            </button>
          )}
          <h2 id={titleId}>{title}</h2>
          {presentation === 'standard' && (
            <button type="button" aria-label="Закрыть выбор карт" onClick={onClose}>
              ×
            </button>
          )}
        </header>
      )}
      {children}
    </dialog>
  );
}
